import dynamic from 'next/dynamic'

export const Fieldset = dynamic(() => import('./fieldset'), { ssr: false })
